<template>
    <div class="container">
        <div class="noprint" style="text-align:right;">
            <button type="button"
                  class="btn btn-dark" 
                  @click="print">
                  <i class="fas fa-print"></i>
                  {{$t("message.print")}}
            </button>
        </div>
        
        <div v-if="show">
            <div class="header-logo">
                <div class="invoice_number">
                    <p class="no-pad">លេខ: {{currentInvoice.invoice_number}}</p>
                    <p>T.ID: {{currentInvoice.transaction_id}}</p>
                </div>
                <div class="logo-brand">
                    <img src="../../assets/secclogo.png" />
                    <h3 class="font-moul">{{$t("message.serc")}}</h3>
                </div>
                <div class="title">
                    <p class="font-moul no-pad">បង្កាន់ដៃបង់ប្រាក់</p>
                    <p>Receipt</p>
                </div>
            </div>
            <div class="invoice_body">
                <p>ទទួលពីឈ្មោះ <span class="font-moul">{{currentInvoice.paid_by.lastname_en + ' ' + currentInvoice.paid_by.firstname_en}}</span>  <span v-if="currentInvoice.paid_by.participant_type==2">តាមរយៈ <b>{{currentInvoice.paid_by.company_name}}.</b></span></p>
                <div class="table-responsive">
                    <table class="table table-bordered pt-2">
                        <thead class="table-dark">
                            <tr>
                                <th class="text-center">#</th>
                                <th>ឈ្មោះ/Name</th>
                                <th class="text-center">ប្រភេទ/Type</th>
                                <th class="text-center" style="width:120px;">ចំនួន/Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in currentInvoice.items" :key="index">
                                <td class="text-center align-middle">
                                    {{index+1}}
                                </td>
                                <td class="align-middle">
                                    <b>{{item.registration_item.participant.lastname_en + ' ' + item.registration_item.participant.firstname_en}}</b>
                                    <p class="no-pad">{{item.registration_item.type_business_name}}</p>
                                </td>
                                <td class="text-center align-middle">{{item.registration_item.apply_for==1? "NEW" : "CPE"}}</td>
                                <td class="text-center align-middle">{{fomartTotal(item.amount)}} KHR</td>
                            </tr>
                            <tr>
                                <td colspan="3" class="text-center">សរុប/Total:</td>
                                <td class="text-center align-middle">{{fomartTotal(currentInvoice.total_amount)}} KHR</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p style="text-align: justify;">
                    អត្ថន័យចំណូលៈ ថ្លៃចុះឈ្មោះចូលរួមសម្រាប់វគ្គបណ្ដុះបណ្ដាលនិងការប្រឡង និងកម្មវិធីអប់រំវិជ្ជាជីវៈបន្តរបស់និយ័តករមូលបត្រកម្ពុជា។
                </p>
            </div>
            <div class="p_foot">
                <p>បានបង់ប្រាក់នៅថ្ងៃទី/Paid At {{currentInvoice.paid_at}}</p>
            </div>

        </div>
        <div v-else>
            <div style="height:500px;"></div>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";
export default {
    data() {
        return {
            currentInvoice: {},
            show:false
        };
    },
    methods: {
        print() {
            window.print();
        },
        showLoader() {
            return this.$loading.show({
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
        },
        async getInvoiceDetail(){
            let loader = this.showLoader();
            this.show = false;
            this.currentInvoice = {};
            const respone = await axios.get("get-detail-payment-history/"+this.$route.params.transactionId, {
                headers: {
                Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
            });
            if (respone.status == 200) {
                this.currentInvoice = respone.data.data;
                //console.log("this data member:",this.currentInvoice);
            }
            loader.hide();
            this.show = true;
        },
    },computed :{
        fomartTotal(){
            return (n) => {
                return Number((n).toFixed(1)).toLocaleString();
            }
        },
        getBusinessType(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.stock_business");
                    case '2':
                    case 2:
                        return this.$t("message.derivative_business");
                    case '19':
                    case 19:
                        return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
                    case 20:
                    case '20':
                        return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
                    default:
                        return t;
                }
            }
        }
    },
    created() {
        this.getInvoiceDetail();
    },
    mounted() {
        //this.getInvoiceDetail();
    }
}
</script>

<style scoped>
    .invoice_number{
        position: relative;
        right: 0;
        float: right;
        width: 150px;
        margin-top: 30px;
        font-size: 11pt;
    }
    .logo-brand {
        width: 250px;
        float: left;
        text-align: center;
        font-size: 11pt;
    }
    .logo-brand img{
        width: 180px;
    }
    .logo-brand h3{
        font-size: 11pt;
    }
    .title{
        clear: both;
        text-align: center;
        position: relative;
        top: -60px;
        text-decoration: underline;
    }
    .header-logo{
        display: block;
    }
    .invoice_body{
        padding: 0 30px;
        font-size: 10pt;
        margin-top: -30px;
        /* border: 1px solid #000; */
    }
    .no-pad {
        margin:0;
        padding:0;
    }
    .p_foot{
        padding: 30px;
        text-align: right;
        font-size: 10pt;
    }
    @media print {
        .container{
            width: 100%;
            margin: auto;
            padding: 0;
            font-size: 11pt;
        }
        .footer{
            display: none;
        }
    }
</style>